import React from 'react'
import {BaseStatusTag} from '@modifi/ui'
import {InferPropTypes} from '@modifi/typescript-utils'
import * as PropTypes from 'prop-types'
import {BankTransactionTagCategory, BankTransactionTagCategoryVal} from '@modifi/enums'
import {useTranslation} from '@modifi/plugin-i18n'
import {yellow, mediumGray} from '@modifi/colors'

type StatusComponentProps = {
  backgroundColor: string
  label: string
}

const getStatusComponent = (
  status?: BankTransactionTagCategoryVal | null
): StatusComponentProps | null => {
  switch (status) {
    case BankTransactionTagCategory.NOT_APPLICABLE:
      return {
        backgroundColor: mediumGray,
        label: 'transaction-status.NOT_APPLICABLE',
      }
    case BankTransactionTagCategory.REMITTANCE_REQUESTED:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.REMITTANCE_REQUESTED',
      }
    case BankTransactionTagCategory.PASSTHROUGH:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.PASSTHROUGH',
      }
    case BankTransactionTagCategory.INTERNAL_TRANSFER:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.INTERNAL_TRANSFER',
      }
    case BankTransactionTagCategory.SETUP_FEE:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.SETUP_FEE',
      }
    case BankTransactionTagCategory.OVERPAYMENT:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.OVERPAYMENT',
      }
    case BankTransactionTagCategory.RETURNED_PAYMENT:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.RETURNED_PAYMENT',
      }
    case BankTransactionTagCategory.REFUND_REQUEST:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.REFUND_REQUEST',
      }
    case BankTransactionTagCategory.FX_GAIN_LOSS:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.FX_GAIN_LOSS',
      }
    case BankTransactionTagCategory.OTHER:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.OTHER',
      }
    case BankTransactionTagCategory.PRE_PAYMENT:
      return {
        backgroundColor: yellow,
        label: 'transaction-status.PRE_PAYMENT',
      }
    default:
      return {
        backgroundColor: mediumGray,
        label: 'transaction-status.NOT_SET',
      }
  }
}

const propTypes = {
  status: PropTypes.oneOf(Object.values(BankTransactionTagCategory)),
}

const defaultProps = {
  status: null,
}

type TradePartnerOrderStatusTagProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const TransactionStatusTag: React.FC<TradePartnerOrderStatusTagProps> = ({status}) => {
  const {t} = useTranslation('moneta')
  const statusComponentProps = getStatusComponent(status)
  if (!statusComponentProps) return null
  const {backgroundColor, label} = statusComponentProps
  return (
    <BaseStatusTag backgroundColor={backgroundColor} dataIdent="transaction-status-tag">
      {t(label)}
    </BaseStatusTag>
  )
}

TransactionStatusTag.propTypes = propTypes
TransactionStatusTag.defaultProps = defaultProps

export default TransactionStatusTag
